import queryInvoiceByAppointmentIds from "services/invoicing/queryInvoiceByAppointmentIds";

const INTERVAL_MS = 5000;
const MAX_ATTEMPTS = 20;

const waitForInvoice = (appointmentId: number, onBehalfOf?: string): Promise<InvoiceData> =>
  new Promise((resolve, reject) => {
    let remainingAttempts = MAX_ATTEMPTS;

    const intervalId = setInterval(async () => {
      try {
        const { invoices } = await queryInvoiceByAppointmentIds(appointmentId, onBehalfOf);
        if (Array.isArray(invoices) && invoices.length > 0) {
          clearInterval(intervalId);
          resolve(invoices[0] as InvoiceData);
        } else {
          if (remainingAttempts-- <= 0) {
            clearInterval(intervalId);
            reject(new Error("timed out waiting for invoice"));
          }
        }
      } catch (e) {
        clearInterval(intervalId);
        reject(e);
      }
    }, INTERVAL_MS);
  });

export default waitForInvoice;
